// import { label } from 'three/examples/jsm/nodes/Nodes.js';
import boxArrowRight from '../../assets/box-arrow-right.svg';
import gear from '../../assets/gear.svg';
import { BiHome, BiBarChartAlt2,BiCoinStack,BiCategoryAlt
    ,BiSolidStoreAlt,BiVial,BiUpload,BiCloudUpload,BiPieChartAlt2,BiSolidBriefcase,BiFirstAid,BiSitemap,
    BiSolidBackpack,BiSolidCapsule,BiAnalyse,BiFile,BiSolidUserPlus,BiClipboard,BiDetail,BiReceipt,BiLineChart,BiSolidCartAdd } from "react-icons/bi";



export const DASHBOARD_SIDEBAR_LINKS ={
    ADMIN:[
    {
        key: "Home",
        label: "Home",
        path: "/home",
        icon:<BiHome/>
    },
    
    {
        key: "Fileuploads",
        label: "Uploads/Dowloads",
        icon: <BiCloudUpload/>,
        submenu: [
            {
                key: "fileUploadDetails",
                label: "Stockist Report",
                path: "/fileuploaddetails",
                icon:<BiCloudUpload/>
            },
            {
                key: "mappingFileUploadDetails",
                label: "Mapping Files ",
                path: "/mappingfileuploaddetails",
                icon:<BiUpload/>
            },  
            // {
            //     key: "monthlyreport",
            //     label: "Monthly Report",
            //     path: "/monthlyreport",
            //     icon: <BiFile/>
            // },
            
        ],
    },

    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon:<BiCoinStack/>
            },   
           
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon:<BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon:<BiFirstAid/>
            },
        ],
    },
    {
        key: "Reorts",
        label: "Reports",
        icon: <BiClipboard/>,
        submenu: [
            {
                key:"contribution",
                label:"Contribution",
                path:"/percentcontribution",
                icon:<BiReceipt/>
            },
            {
                key: "repflowchart",
                label: "Rep Flow Chart",
                path: "/repflowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "doctorflowchart",
                label: "Doctor Flow Chart",
                path: "/doctorflowchart",
                icon: <BiPieChartAlt2/>
            },
            {
                key: "productflowchart",
                label: "Product Flow Chart",
                path: "/productflowchart",
                icon: <BiVial/>
            },
             {
                key: "doctorwiseproductflowchart",
                label: "Doctor Wise Product Flow Chart",
                path: "/doctor-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "locationwiseproductflowchart",
                label: "Location Wise Product Flow Chart",
                path: "/location-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "repwiseproductflowchart",
                label: "Rep Wise Product Flow Chart",
                path: "/rep-product-flowchart",
                icon: <BiSolidBackpack/>
            },
            // {
            //     key: "chemistflowchart",
            //     label: "Chemist Flow Chart",
            //     path: "/chemistflowchart",
            //     icon: <BiSolidStoreAlt/>
            // },
            {
                key: "analytics",
                label: "Analytics",
                path: "/analytics",
                icon: <BiLineChart/>
            },
            // {
            //     key: "Advanced",
            //     label: "AdvancedAnalytics",
            //     path: "/advancedanalytics",
            //     icon: <BiPieChartAlt2/>
            // },
        ],
    },
    {
        key:"campaign",
        label:"Campaigns",
        icon:<BiDetail/>,
        submenu: [
            // {
            //     key:"campaign",
            //     label:"Campaigns",
            //     path:"/campaign",
            //     icon:<BiDetail/>
            // },
            {
                key:"createcampaign",
                label:"Create Campaign",
                path:"/createcampaign",
                icon:<BiDetail/>
            },
            {
                key:"allcampaign",
                label:"All Campaigns",
                path:"/allcampaign",
                icon:<BiDetail/>
            }
        ]
    },
    
    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd />,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        {
            key: "productmapping",
            label: "Product Mapping",
            path: "/productmapping",
            icon: <BiAnalyse/>
          },
          
        ],
      },
    {
        key:"createUser",
        label:"Create User",
        path:"/createuser",
        icon:<BiSolidUserPlus/>
    },
    {
        key:"userhierarchy",
        label:"User Hierarchy",
        path:"/userhierarchy",
        icon:<BiDetail/>
    },
    {
        key:"docrepmapping",
        label:"Doc-Rep Mapping",
        path:"/docrepmapping",
        icon:<BiSitemap/>
    },
    

],
SUPER_USER:[
    {
        key: "Home",
        label: "Home",
        path: "/home",
        icon:<BiHome/>
    },

    {
        key: "Fileuploads",
        label: "Uploads/Downloads",
        icon: <BiCloudUpload/>,
        submenu: [
            {
                key: "fileUploadDetails",
                label: "Stockist Report",
                path: "/fileuploaddetails",
                icon:<BiCloudUpload/>
            },
            {
                key: "mappingFileUploadDetails",
                label: "Mapping Files ",
                path: "/mappingfileuploaddetails",
                icon:<BiUpload/>
            },  
            {
                key: "monthlyreport",
                label: "Monthly Report",
                path: "/monthlyreport",
                icon: <BiFile/>
            },
        ],
    },

    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon:<BiCoinStack/>
            },   
           
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon:<BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon:<BiFirstAid/>
            },
        ],
    },
    {
        key: "Reorts",
        label: "Reports",
        icon: <BiClipboard/>,
        submenu: [
            {
                key:"contribution",
                label:"Contribution",
                path:"/percentcontribution",
                icon:<BiReceipt/>
            },
            {
                key: "repflowchart",
                label: "Rep Flow Chart",
                path: "/repflowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "doctorflowchart",
                label: "Doctor Flow Chart",
                path: "/doctorflowchart",
                icon: <BiPieChartAlt2/>
            },
            {
                key: "productflowchart",
                label: "Product Flow Chart",
                path: "/productflowchart",
                icon: <BiVial/>
            },
             {
                key: "doctorwiseproductflowchart",
                label: "Doctor Wise Product Flow Chart",
                path: "/doctor-wise-flowchart",
                icon: <BiVial/>
            },
              {
                key: "locationwiseproductflowchart",
                label: "Location Wise Product Flow Chart",
                path: "/location-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "repwiseproductflowchart",
                label: "Rep Wise Product Flow Chart",
                path: "/rep-product-flowchart",
                icon: <BiSolidBackpack/>
            },
            // {
            //     key: "chemistflowchart",
            //     label: "Chemist Flow Chart",
            //     path: "/chemistflowchart",
            //     icon: <BiSolidStoreAlt/>
            // },
            {
                key: "analytics",
                label: "Analytics",
                path: "/analytics",
                icon: <BiLineChart/>
            },
            // {
            //     key: "Advanced",
            //     label: "AdvancedAnalytics",
            //     path: "/advancedanalytics",
            //     icon: <BiPieChartAlt2/>
            // },
        ],
    },
    {
        key:"campaign",
        label:"Campaigns",
        icon:<BiDetail/>,
        submenu: [
            // {
            //     key:"campaign",
            //     label:"Campaigns",
            //     path:"/campaign",
            //     icon:<BiDetail/>
            // },
            {
                key:"createcampaign",
                label:"Create Campaign",
                path:"/createcampaign",
                icon:<BiDetail/>
            },
            {
                key:"allcampaign",
                label:"All Campaigns",
                path:"/allcampaign",
                icon:<BiDetail/>
            }
        ]
    },

    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd />,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        {
            key: "productmapping",
            label: "Product Mapping",
            path: "/productmapping",
            icon: <BiAnalyse/>
          },
          
        ],
      },
    {
        key:"createUser",
        label:"Create User",
        path:"/createuser",
        icon:<BiSolidUserPlus/>
    },
    {
        key:"userhierarchy",
        label:"User Hierarchy",
        path:"/userhierarchy",
        icon:<BiDetail/>
    },
    {
        key:"docrepmapping",
        label:"Doc-Rep Mapping",
        path:"/docrepmapping",
        icon:<BiSitemap/>
    },

],
REGULAR_USER:[
    
    {
        key: "Fileuploads",
        label: "Uploads/Downloads",
        icon: <BiCloudUpload/>,
        submenu: [
            {
                key: "fileUploadDetails",
                label: "Stockist Report",
                path: "/fileuploaddetails",
                icon:<BiCloudUpload/>
            },
            {
                key: "mappingFileUploadDetails",
                label: "Mapping Files ",
                path: "/mappingfileuploaddetails",
                icon:<BiUpload/>
            },  
            // {
            //     key: "monthlyreport",
            //     label: "Monthly Report",
            //     path: "/monthlyreport",
            //     icon: <BiFile/>
            // },
        ],
    },

    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon:<BiCoinStack/>
            },   
           
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon:<BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon:<BiFirstAid/>
            },
        ],
    },
    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd />,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        {
            key: "productmapping",
            label: "Product Mapping",
            path: "/productmapping",
            icon: <BiAnalyse/>
          },
          
        ],
      },
    {
        key:"docrepmapping",
        label:"Doc-Rep Mapping",
        path:"/docrepmapping",
        icon:<BiSitemap/>
    },

],
REPRESENTATIVE: [
    {
        key: "Home",
        label: "Home",
        path: "/home",
        icon:<BiHome/>
    },
    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon: <BiCoinStack/>
            },
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon: <BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon: <BiFirstAid/>
            },
        ],
    },
    {
        key: "Reorts",
        label: "Reports",
        icon: <BiClipboard/>,
        submenu: [
            {
                key: "contribution",
                label: "Contribution",
                path: "/percentcontribution",
                icon: <BiReceipt/>
            },
            {
                key: "repflowchart",
                label: "Rep Flow Chart",
                path: "/repflowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "doctorflowchart",
                label: "Doctor Flow Chart",
                path: "/doctorflowchart",
                icon: <BiPieChartAlt2/>
            },
            {
                key: "productflowchart",
                label: "Product Flow Chart",
                path: "/productflowchart",
                icon: <BiVial/>
            },
            {
                key: "doctorwiseproductflowchart",
                label: "Doctor Wise Product Flow Chart",
                path: "/doctor-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "locationwiseproductflowchart",
                label: "Location Wise Product Flow Chart",
                path: "/location-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "repwiseproductflowchart",
                label: "Rep Wise Product Flow Chart",
                path: "/rep-product-flowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "analytics",
                label: "Analytics",
                path: "/analytics",
                icon: <BiLineChart/>
            },
        ],
    },
    {
        key: "campaign",
        label: "Campaigns",
        icon: <BiDetail/>,
        submenu: [
            {
                key: "allcampaign",
                label: "All Campaigns",
                path: "/allcampaign",
                icon: <BiDetail/>
            },
        ],
    },
    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd/>,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        ],
    },
],
ABM: [
    {
        key: "Home",
        label: "Home",
        path: "/home",
        icon:<BiHome/>
    },
    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon: <BiCoinStack/>
            },
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon: <BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon: <BiFirstAid/>
            },
        ],
    },
    {
        key: "Reorts",
        label: "Reports",
        icon: <BiClipboard/>,
        submenu: [
            {
                key: "contribution",
                label: "Contribution",
                path: "/percentcontribution",
                icon: <BiReceipt/>
            },
            {
                key: "repflowchart",
                label: "Rep Flow Chart",
                path: "/repflowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "doctorflowchart",
                label: "Doctor Flow Chart",
                path: "/doctorflowchart",
                icon: <BiPieChartAlt2/>
            },
            {
                key: "productflowchart",
                label: "Product Flow Chart",
                path: "/productflowchart",
                icon: <BiVial/>
            },
            {
                key: "doctorwiseproductflowchart",
                label: "Doctor Wise Product Flow Chart",
                path: "/doctor-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "locationwiseproductflowchart",
                label: "Location Wise Product Flow Chart",
                path: "/location-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "repwiseproductflowchart",
                label: "Rep Wise Product Flow Chart",
                path: "/rep-product-flowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "analytics",
                label: "Analytics",
                path: "/analytics",
                icon: <BiLineChart/>
            },
        ],
    },
    {
        key: "campaign",
        label: "Campaigns",
        icon: <BiDetail/>,
        submenu: [
            {
                key: "allcampaign",
                label: "All Campaigns",
                path: "/allcampaign",
                icon: <BiDetail/>
            },
        ],
    },
    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd/>,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        ],
    },
],
RBM: [
    {
        key: "Home",
        label: "Home",
        path: "/home",
        icon:<BiHome/>
    },
    {
        key: "SalesChannels",
        label: "Sales Channels",
        icon: <BiBarChartAlt2/>,
        submenu: [
            {
                key: "dashboard",
                label: "Stockist",
                path: "/dashboard",
                icon: <BiCoinStack/>
            },
            {
                key: "Representatives",
                label: "Representatives",
                path: "/representatives",
                icon: <BiSolidBriefcase/>
            },
            {
                key: "doctor",
                label: "Doctors",
                path: "/doctor",
                icon: <BiFirstAid/>
            },
        ],
    },
    {
        key: "Reorts",
        label: "Reports",
        icon: <BiClipboard/>,
        submenu: [
            {
                key: "contribution",
                label: "Contribution",
                path: "/percentcontribution",
                icon: <BiReceipt/>
            },
            {
                key: "repflowchart",
                label: "Rep Flow Chart",
                path: "/repflowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "doctorflowchart",
                label: "Doctor Flow Chart",
                path: "/doctorflowchart",
                icon: <BiPieChartAlt2/>
            },
            {
                key: "productflowchart",
                label: "Product Flow Chart",
                path: "/productflowchart",
                icon: <BiVial/>
            },
            {
                key: "doctorwiseproductflowchart",
                label: "Doctor Wise Product Flow Chart",
                path: "/doctor-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "locationwiseproductflowchart",
                label: "Location Wise Product Flow Chart",
                path: "/location-wise-flowchart",
                icon: <BiVial/>
            },
            {
                key: "repwiseproductflowchart",
                label: "Rep Wise Product Flow Chart",
                path: "/rep-product-flowchart",
                icon: <BiSolidBackpack/>
            },
            {
                key: "analytics",
                label: "Analytics",
                path: "/analytics",
                icon: <BiLineChart/>
            },
        ],
    },
    {
        key: "campaign",
        label: "Campaigns",
        icon: <BiDetail/>,
        submenu: [
            {
                key: "allcampaign",
                label: "All Campaigns",
                path: "/allcampaign",
                icon: <BiDetail/>
            },
        ],
    },
    {
        key: "Productsubmenu",
        label: "Product Details",
        icon: <BiSolidCartAdd/>,
        submenu: [
            {
                key: "products",
                label: "Products",
                path: "/products",
                icon: <BiSolidCapsule/>
            },
        ],
    },
],
}

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = [
    {
        key: "settings",
        label: "Settings",
        path: "/settings",
        icon:gear
    },
    {
        key: "logout",
        label: "Logout",
        path: "/logout",
        icon:boxArrowRight
    },
   
]